// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1TnDo","tab":"Tabs_tab__1PQaF","tabActive":"Tabs_tabActive__A5Dno"};